import { Outlet } from "react-router-dom";
import Superheader from '../components/KalHome/Superheader';
import Endfooter from '../components/Homecomponents/Endfooter';
import Header from "../components/KalHome/Header";
import Footer from "../components/Homecomponents/Footer";
import { useEffect, useState } from "react";
import SocialLinks from "../components/Homecomponents/Sociallinks";
import Headerads from "../components/KalHome/Headerads";
import Prefooterads from "../components/Homecomponents/Prefooterads";
import Newsletter from "../components/Homecomponents/Newsletter";

const FullLayout = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>
      <Headerads />
      <Outlet />
      <Prefooterads />
      <Newsletter />
      <Footer />
      <SocialLinks />
      <Endfooter />
    </>
  )
}

export default FullLayout